import { Component, Input } from '@angular/core';
import { SchillerFilters } from '../ecg-fab-tools/layout-fab-tools/layout-fab-tools.component';
import { FilterType, IFilter } from '../models/ifilter';

@Component({
    selector: 'fixed-filters',
    templateUrl: './fixed-filters.component.html',
    styleUrls: ['./fixed-filters.component.css'],
})
export class FixedFiltersComponent {
    // Data Members

    private _filters: Array<IFilter> | null = null;
    get filters() {
        return this._filters;
    }
    @Input()
    set filters(filters) {
        if (filters !== null) this._filters = filters.filter((filter) => filter.type == FilterType.fixed);
        else this._filters = null;

        this.extractBaseFilters();
    }

    @Input() schillerFilters!: SchillerFilters;
    @Input() manufacturer!: string;

    lowPass: IFilter | null = null;
    highPass: IFilter | null = null;
    notch: IFilter | null = null;

    // private functions

    extractBaseFilters() {
        this.lowPass =
            this.filters !== null
                ? this.filters.find((filter) => filter.name.toLowerCase().indexOf('lowpass') >= 0) ?? null
                : null;
        this.highPass =
            this.filters !== null
                ? this.filters.find((filter) => filter.name.toLowerCase().indexOf('highpass') >= 0) ?? null
                : null;
        this.notch =
            this.filters !== null
                ? this.filters.find((filter) => filter.name.toLowerCase().indexOf('mains') >= 0) ?? null
                : null;
    }
}
